import React from "react";
import { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { changeSidebarState } from "../../redux/reducers/sidebar-reducer";
import { styled } from '@mui/material/styles';
import { Link } from "react-router-dom";
import MuiDrawer from '@mui/material/Drawer';
import MuiSwipeableDrawer from '@mui/material/SwipeableDrawer';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import IconButton from '@mui/material/IconButton';
import Tooltip from "@mui/material/Tooltip";
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import Logo from "../../assests/logo.png";
import { SidebarData } from "../../const/SidebarData";
import {Box } from "@mui/material";
import { useSelector } from "react-redux";

const drawerWidth = 240;

const visualizzazione = "Visualizzazione";
const Drawer = styled(MuiDrawer, { 
    shouldForwardProp: (prop) => prop !== 'open'
})
(({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen
        }),
        width: theme.spacing(8)
      }),
    },
    '& .MuiTypography-root': {
        fontWeight: 500,
        color: '#3e6bb4'
    },
    '& .MuiSvgIcon-root': {
        fontSize: '30px',
        color: '#3e6bb4'
    }
  })
);

const SwipeableDrawer = styled(MuiSwipeableDrawer, { 
    shouldForwardProp: (prop) => prop 
})
(() => ({
    '& .MuiTypography-root': {
        fontWeight: 500,
        color: '#3e6bb4'
    },
    '& .MuiSvgIcon-root': {
        fontSize: '30px',
        color: '#3e6bb4'
    }
  })
);


const Sidebar = ({initialState, xsSize}) => {
    const statePolicies = useSelector((state) => state.userDate.policies);
    const dispatch = useDispatch();
    const { sidebar } = initialState;
    const [sidebarState, setSidebarState] = useState(sidebar);


    const drawerContent = (<>
        <Toolbar
            sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            px: [1],
            }}
        > 
            {
                xsSize ?
                    <></>
                : (
                    <>
                        <img
                            src={Logo}
                            alt="logoDeGroup"
                            title="DEGroup"
                            className="logo"
                        />
                        <IconButton onClick={() => dispatch(changeSidebarState())}>
                            <ChevronLeftIcon />
                        </IconButton>
                    </>
                )
            }
        </Toolbar>
        <List>
            { SidebarData.map((item) => {
                return (
                    statePolicies.map((policy) => {
                        let splitPolicy = policy.split(".");
                        return (
                            item.policy === splitPolicy[0] && splitPolicy[1] === visualizzazione && (
                                <ListItem component={Link} to={item.path} key={item.title} >
                                    <Tooltip disableFocusListener title={item.title}>
                                        <ListItemIcon>
                                            {item.icon}
                                        </ListItemIcon>
                                    </Tooltip>
                                    <ListItemText primary={item.title.toUpperCase()}/>
                                </ListItem>
                            )
                        )
                    })
                )
            })}
        </List>
    </>);
 

    useEffect(() => {
        setSidebarState(sidebar);
    }, [sidebar]);


    return(
        <>
            {
                xsSize ? (
                    <>
                         <SwipeableDrawer
                            anchor={'left'}
                            open={sidebarState}
                            onOpen={() => dispatch(changeSidebarState())}
                            onClose={() => dispatch(changeSidebarState())}
                            onClick={() => dispatch(changeSidebarState())}
                        >
                            <Box
                                sx={{ width: 'auto' }}
                                role="presentation"
                                >
                                {drawerContent}
                            </Box>
                        </SwipeableDrawer>
                    </>
                ) : (
                    <>
                        <Drawer variant="permanent" open={sidebarState} sx={{ fontWeight: 500 }}>
                            {drawerContent}
                        </Drawer>
                    </>
                )
            }
        </>
    );
};

export default Sidebar;